import React, { useRef } from 'react'
import { Button, Form, Input } from 'antd'
import './styles/Contact.module.css'

const { TextArea } = Input

const ContactForm = ({ onSubmit }) => {
  //destructures props
  const [form] = Form.useForm()
  const formRef = useRef()

  return (
    <Form form={form} requiredMark={'optional'} layout={'vertical'} name='ContactForm' onFinish={onSubmit}>
      <div style={{ display: 'flex', flex: '1 1' }}>
        <Form.Item
          style={{ width: '100%' }}
          name='first_name'
          label='First Name'
          rules={[
            {
              required: true,
              message: 'Please input your name!',
              type: 'string',
              max: 100,
              min: 1
            }
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          style={{ width: '100%' }}
          name='last_name'
          label='Last Name'
          rules={[
            {
              required: true,
              message: 'Please input your name!',
              type: 'string',
              max: 100,
              min: 1
            }
          ]}
        >
          <Input />
        </Form.Item>
      </div>
      <div style={{ display: 'flex', flex: '1 1' }}>
        <Form.Item
          style={{ width: '100%' }}
          name='email'
          label='Email'
          rules={[
            {
              required: true,
              message: 'Please input your email!',
              type: 'string',
              max: 100,
              min: 1
            }
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          style={{ width: '100%' }}
          name='phone'
          label='Phone'
          rules={[
            {
              required: false,
              type: 'string',
              max: 100,
              min: 1
            }
          ]}
        >
          <Input />
        </Form.Item>
      </div>
      <div style={{ paddingTop: 2, paddingBottom: 12 }}>Leave us a message ...</div>
      <Form.Item
        name='message'
        rules={[
          {
            required: false,
            message: '',
            type: 'string',
            max: 10240,
            min: 1
          }
        ]}
      >
        <TextArea rows={8} maxLength={1024} showCount={true} />
      </Form.Item>
      <Button
        htmlType='submit'
        style={{
          float: 'right',
          color: 'white',
          backgroundColor: 'black',
          width: '100%',
          height: 48
        }}
      >
        Submit
      </Button>
    </Form>
  )
}

export default ContactForm
